import styled, { css } from 'styled-components'

import {
  SizeSelector as LMFSizeSelector,
  TypeStyle,
  fromMd,
  timingDefault,
  untilMd,
  withHoverSupport,
  zIndexForeground,
} from '@syconium/little-miss-figgy'

const SelectorWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`

const SizeSelector = styled(LMFSizeSelector)`
  justify-content: ${o => (o.minWidthStyle === 'lg' ? 'center' : 'start')};
  max-width: ${o => (o.minWidthStyle === 'lg' && '338px') || (o.minWidthStyle === 'md' && '226px')};

  ${fromMd} {
    justify-content: ${o => o.minWidthStyle === 'lg' && 'center'};
    margin-top: 0;
    margin-bottom: -8px;
    margin-inline-start: 0;
    margin-inline-end: -8px;
  }
`

const SizeSelectorWrapper = styled(SelectorWrapper)<{ extendedFixedWidthItems?: boolean }>`
  padding: ${o => (o.extendedFixedWidthItems ? '12px 14px' : '12px 28px')};
`

export const Body = styled(TypeStyle.HeadlineMicro)<{
  $ctaOnly: boolean
  $heightPixels?: number
  $hideOnDesktop: boolean
  $isFavorites?: boolean
  $useLargeWidthSizeSelectorItems?: boolean
}>`
  bottom: 0;
  cursor: pointer;
  justify-content: center;
  opacity: 1;
  line-height: 0px;
  position: absolute;
  transition-property: height, opacity;
  transition-duration: ${timingDefault};
  transition-timing-function: ease;
  z-index: ${zIndexForeground};
  visibility: ${o => o.$isFavorites && 'hidden'};

  ${withHoverSupport} {
    ${o =>
      o.$useLargeWidthSizeSelectorItems &&
      !o.$ctaOnly &&
      css`
        height: 431px;
      `};
  }

  @media screen and (max-width: 1200px) {
    ${SizeSelectorWrapper} {
      margin-top: 50%;
      padding: 86px 8px 45px 8px;
    }
    ${SizeSelector} {
      max-width: 170px;
      max-height: 280px;
      margin-top: 42%;
      overflow-y: scroll;
      -ms-overflow-style: none;

      ::-webkit-scrollbar {
        display: none;
      }
    }
  }

  ${withHoverSupport} {
    pointer-events: ${o => o.$hideOnDesktop && 'none'};
    visibility: hidden;
    &:hover {
      visibility: visible;
    }
  }

  ${untilMd} {
    bottom: ${o => o.theme.spacing(2)};
    right: ${o => o.theme.spacing(2)};
  }

  ${fromMd} {
    visibility: ${o => o.$hideOnDesktop && 'hidden'};
    bottom: ${o => o.theme.spacing(3)};
    right: ${o => o.theme.spacing(3)};
  }
`
